// ---------------------------------------------------------------------------
// Platform detection — are we running inside the native SouleMap app?
//
// Purchases (star lightings, Forever, donations) are hidden inside the iOS
// app to comply with Apple's App Store guideline 3.1.1: digital goods bought
// in-app must use Apple's In-App Purchase. Everything remains purchasable on
// the website. When we later adopt IAP or approved external-purchase links,
// this flag is where the gating lives.
//
// Detection: the Capacitor bridge is injected into the page when loaded by
// the native shell; a custom user-agent marker is the belt-and-suspenders.
// ---------------------------------------------------------------------------

export function isInNativeApp() {
  try {
    if (window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function') {
      return window.Capacitor.isNativePlatform();
    }
    if (window.Capacitor) return true;
    return /SouleMapApp/i.test(navigator.userAgent || '');
  } catch (e) {
    return false;
  }
}
